import Swiper from 'swiper'
import { Navigation, Pagination, A11y, Scrollbar } from 'swiper/modules'
import { activeUnactiveNav } from './gallery-slider'
import 'swiper/swiper-bundle.css'
Swiper.use([Navigation, Pagination, A11y, Scrollbar])

const historySlider = (historyDiv) => {
    const swiper = new Swiper(historyDiv , {
        modules: [Navigation, Pagination, Scrollbar],
        spaceBetween: 100,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
            loopAdditionalSlides: 100,
            renderBullet: function (index, className) {
                return '<li class="' + className + '"><span class="bullet-color"></span><span class="bullet-text">' + document.querySelectorAll('.ia-block-listing-history__item__info h3')[(index)].innerText + '</span></li>';
              },
        },
        breakpoints: {
            320: {
                slidesPerView: 1.2,
                spaceBetween: 20,
            },

            1024: {
                slidesPerView: 1,
            }
        },
        on: {
            init: function(){
                changePreviewImage(historyDiv, false)
            },
            beforeTransitionStart: function(e){
                let isEnd = false
                if (e.isEnd) {
                    isEnd = true
                }
                    changePreviewImage(historyDiv, isEnd)
                
            },
            slideChange: function(e){
                activeUnactiveNav(e, historyDiv)
            }
        }
    })
    
    historyDiv.querySelector('.next-slide-image-preview').addEventListener('click', function(){
        swiper.slideNext()
    })
    swiper.init()


    historyDiv.querySelector('.ia-custom-navigation__swiper-button-next').addEventListener('click', function(e) {
        e.preventDefault()
        swiper.slideNext()
    })
    historyDiv.querySelector('.ia-custom-navigation__swiper-button-prev').addEventListener('click', function(e) {
        e.preventDefault()
        swiper.slidePrev()
    })
}

function changePreviewImage(historyDiv, isEnd=false, isBegin=false) {
    if (!!document.querySelector('.next-slide-image-preview')) {
        historyDiv.parentElement.querySelector('.next-slide-image-preview').classList.add('out')
        if (!isEnd) {
            setTimeout(() => {
                const nextSlideImg = historyDiv.parentElement.querySelector('.swiper-slide-next .slide-picture img').cloneNode(true)
                historyDiv.parentElement.querySelectorAll('.next-slide-image-preview').forEach(element => element.innerHTML = '')
                historyDiv.parentElement.querySelector('.next-slide-image-preview').append(nextSlideImg)
                setTimeout(() => {
                    historyDiv.parentElement.querySelector('.next-slide-image-preview').classList.remove('out')
                }, 40);
            }, 300);
        }
    }

    if (!!document.querySelector('.prev-slide-image-preview')) {
        historyDiv.parentElement.querySelector('.prev-slide-image-preview').classList.add('out')
        if (!isBegin) {
            setTimeout(() => {
                const nextSlideImg = historyDiv.parentElement.querySelector('.swiper-slide-prev .slide-picture img').cloneNode(true)
                historyDiv.parentElement.querySelectorAll('.prev-slide-image-preview').forEach(element => element.innerHTML = '')
                historyDiv.parentElement.querySelector('.prev-slide-image-preview').append(nextSlideImg)
                setTimeout(() => {
                    historyDiv.parentElement.querySelector('.prev-slide-image-preview').classList.remove('out')
                }, 40);
            }, 300);
        }
    }
    
}

export {historySlider, changePreviewImage}